// initial state
const baseName = '/admin/api/site'

const siteConfig = baseName + '/config'
const siteClearCache = baseName + '/clearCache'

const a = Object.assign({siteConfig, siteClearCache})
export default a
